import { Typography } from '@hmsexp/component-library';
import React, { useRef } from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import Table from '../../../../../../components/Common/Table';
import { View } from '../../../../../../components/Common/react-native-components';
import { topBottomMetrixStyling } from './style';
import get from 'lodash/get';
import GraphTable from '../../../../../../components/Common/GraphTable';
import { useTransformTopAndBottomChartData } from '../../../../hooks/useTransformTopAndBottomChartData';
import {
  convertCstDataIntoBarChartCompatible,
  convertCstDataIntoTableCompatibleData,
  getMonthWithValues
} from '../../../../../../utils/transformChartsAndTableData';
import GenericNoData from '../../../../../../components/Common/NoData/GenricNoData';
import { handleHighChartsExport } from '../../../../utils';
import MultiFeatureCard from '../../../../../../components/Common/Card/MultiOptionsCard/MultiFeatureCard';
import LowerSampleSizeFooter from '../../../../../../components/Common/LowerSampleSizeFooter';
const TopBottomProperties = (props) => {
  const { item, timeperiodLabel } = props;

  const styles = topBottomMetrixStyling();

  const options = get(item, 'data.bar_chart_default_data');
  const table_line_chart_default_data = get(item, 'data.table_line_chart_default_data');
  const chartOptions = useTransformTopAndBottomChartData(options);
  const allowedClumns = ['rank', 'property', 'No of records', 'Total', 'Benchmark', 'Delta'];

  const chartRef = useRef(null);

  const actionButtonClick = e => {
    handleHighChartsExport(e, chartRef, item);
  };
  if (!get(item, 'cstData') || !get(item, 'cstData.metric_data.length')) {
    return <GenericNoData />;
  }
  const tableData = convertCstDataIntoTableCompatibleData(get(item, 'cstData') || {}, allowedClumns);
  const graphTableData = convertCstDataIntoTableCompatibleData(get(item, 'cstData') || {});
  const barChartData = convertCstDataIntoBarChartCompatible(get(item, 'cstData') || {}, chartOptions);

  const color = get(options, 'series[0].color');

  function renderContent(activeSwitch) {
    switch (activeSwitch) {
      case 'BAR':
        return (
          <>
            <View style={{ height: 300 }}>
              <HighchartsReact ref={chartRef} highcharts={Highcharts} options={barChartData} />
            </View>
            <View style={{ flexDirection: 'row', justifyContent: 'flex-end', marginTop: 20 }}>
              <View style={[styles.selectedMetrixContainer, { borderColor: color }]}>
                <View style={{ width: 10, height: 10, backgroundColor: color }}></View>
                <Typography fontWeightType='regular' variant='button'>
                  {get(options, "yAxis.title.text")}
                </Typography>
              </View>
            </View>
          </>
        );
      case 'TIME':
        const graph_table_data = {
          ...graphTableData,
          table_rows: get(graphTableData, 'table_rows', []).map(row => {
            const monthData = getMonthWithValues(row);
            const options = {
              ...table_line_chart_default_data,
              xAxis: {
                ...table_line_chart_default_data.xAxis,
                categories: monthData.months
              },
              series: table_line_chart_default_data.series.map((s, i) => ({
                ...s,
                data: i === 0 ? monthData.data : s.data
              }))
            };
            return {
              ...row,
              nested_rows: [
                {
                  [get(graphTableData, 'table_columns[0].field')]: {
                    chart_options: options
                  }
                }
              ]
            };
          })
        };
        return <GraphTable lowSampleSize={get(item, 'lowSampleSize')} graph_table_data={{ table_data: graph_table_data }} />;
      case 'TABLE':
        return (
          <View style={{ height: 'auto' }}>
            <Table lowSampleSize={get(item, 'lowSampleSize')} table_data={tableData} />
          </View>
        );
      default:
        break;
    }
  }

  return (
    <MultiFeatureCard
      title={get(item, 'title')}
      onActionButtonClick={actionButtonClick}
      subTitle={timeperiodLabel}
      style={{ childContainer: { paddingVertical: 20, flex: 1 } }}
      enableActionBtn={get(item, 'enableActionBtn', false)}
      enableSwitchTab={get(item, 'enableSwitchTab', false)}
      switchOptions={get(item, 'switchOptions', [])}
      renderContent={renderContent}
      renderFooter={() => get(item, 'cstData') && <LowerSampleSizeFooter size={get(item, 'lowSampleSize')} />}
    />
  )
}

export default TopBottomProperties;
